import AOS from "./libraries/aos";
import Splide from '@splidejs/splide';
import MicroModal from 'micromodal';
import { tabs } from './components/tabs';
import { shareModal } from './components/shareModal';
import { nav } from './components/nav';
import Slideout from "slideout";
import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";

AOS.init();

MicroModal.init({
  onShow: modal => console.info(`${modal.id} is shown`),
  onClose: modal => console.info(`${modal.id} is hidden`),
  openClass: 'is-open',
  disableScroll: true,
  disableFocus: false,
  awaitOpenAnimation: false,
  awaitCloseAnimation: false,
  debugMode: true
});

/*function inits() {
  AOS.init({
      duration: 1000,
      easing: 'ease',
      once: true
  });
}*/

const splideElement = document.getElementsByClassName('splide')
if (splideElement.length > 0) {
  new Splide( '.splide' ).mount();
}

//inits();
nav();
tabs();
shareModal();